

export const statusOptions = [
	{
		label: '合作中',
		value: 1
	},
	{
		label: '停止合作',
		value: 2
	}
]

export const showOrderValidNumOptions = [
	{
		label: '是',
		value: 1
	},
	{
		label: '否',
		value: 2
	}
]

export const renderList = [
	{
		label: '客户名称',
		key: 'name',
		type: 'input',
		placeholder: '请输入'
	}
]

export const renderMobileList = [
	{
		label: '客户名称',
		key: 'name',
		type: 'input',
		placeholder: '请输入'
	}
]


export const formRenderList = [
	{
		label: '客户名称',
		type: 'input',
		placeholder: '请输入公司主体名称',
		key: 'name',
		maxLength: 50,
		require: true
	},
	{
		label: '状态',
		type: 'select',
		placeholder: '请选择状态',
		options: statusOptions,
		key: 'status',
		require: true
	},
	{
		label: '是否显示净销售额',
		type: 'select',
		placeholder: '请选择是否显示净销售额',
		key: 'showOrderValidNum',
		options: showOrderValidNumOptions,
		require: true
	},
	{
		label: '备注',
		type: 'textarea',
		placeholder: '请输入备注',
		key: 'notes',
		maxLength: 100,
		require: true
	},
]

export const formRules = {
	name: [
		{ required: true, message: '请输入公司主体名称', trigger: 'blur' }
	],
	status: [
		{ required: true, message: '请选择状态', trigger: 'blur', type: 'number' }
	],
	showOrderValidNum: [
		{ required: true, message: '请选择是否显示净销售额', trigger: 'blur', type: 'number' }
	],
	notes: [
		
	]
}




// WEBPACK FOOTER //
// ./src/pages/home/userInfo/customerManage/config.js